import SidebarRailTooltip from "./SidebarRailTooltip.jsx";

// Phase 4-β cleanup (0.5.98) — count badges max out at "99+" so a
// runaway suggestion writer can't push the sidebar wider than its
// fixed rail. The threshold is generous; in practice suggestion
// queues sit in the single digits.
function formatCountBadge(value) {
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) return null;
  if (value > 99) return "99+";
  return String(Math.floor(value));
}

export default function SidebarNavItem({
  as = "button",
  active = false,
  disabled = false,
  label,
  icon,
  badge,
  count,
  dataPage,
  onClick,
  collapsed = false,
}) {
  const countLabel = formatCountBadge(count);

  // ``badge`` is the legacy string slot used for "Soon" labels.
  // ``count`` is the Phase 4-β numeric slot for in-app metrics
  // (pending review-queue suggestions today; potentially other
  // counters later — unread memos, etc.). Both can coexist in
  // theory; in practice no nav item uses both.
  const badgeNode =
    badge != null ? (
      <span className="nav-badge nav-badge-live">
        <span className="nav-badge-dot" />
        {badge}
      </span>
    ) : countLabel != null ? (
      <span
        className="nav-badge nav-badge-count"
        aria-label={`${count} pending`}
      >
        {countLabel}
      </span>
    ) : null;

  const content = (
    <>
      <span className="nav-icon">{icon}</span>
      <span className="nav-label">{label}</span>
      {badgeNode}
    </>
  );

  const collapsedTipBadge = badge || countLabel;
  const collapsedTip =
    collapsed && label
      ? collapsedTipBadge
        ? `${label} (${collapsedTipBadge})`
        : label
      : null;

  if (as === "div") {
    const row = (
      <div className="nav-item" data-page={dataPage} aria-label={collapsedTip || undefined}>
        {content}
      </div>
    );
    return collapsedTip ? <SidebarRailTooltip text={collapsedTip}>{row}</SidebarRailTooltip> : row;
  }

  const btn = (
    <button
      type="button"
      className={`nav-item${active ? " active" : ""}${disabled ? " disabled" : ""}`}
      data-page={dataPage}
      aria-current={active ? "page" : undefined}
      aria-label={collapsedTip || undefined}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );

  return collapsedTip ? <SidebarRailTooltip text={collapsedTip}>{btn}</SidebarRailTooltip> : btn;
}
